module.exports = __webpack_public_path__ + "static/img/confirmation.f6a313a0.png";